<template>
  <div v-if="currentChecklist">
    <div class="row">
      <div class="col-lg-6">
        <BreadCrumd
          :title="'Checklists des entretiens'"
          :description="'Modification d\'une checklist d\'entretien'"
        />
      </div>
      <div class="col-lg-6 mt-lg-4" v-if="currentChecklist">
        <div class="row">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-12 d-flex justify-content-between">
                    Nom de la checklist :
                    {{ currentChecklist.nom }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="
            $router
              .push({
                name: 'rh_entretien_checklist',
              })
              .catch(() => {})
          "
        >
          Liste des checklists
        </button>
        <button
          type="button"
          class="btn btn-custom-primary mr-4"
          @click.prevent="
            $router
              .push({
                name: 'rh_entretien_checklist-create',
              })
              .catch(() => {})
          "
        >
          <i class="fas fa-plus"></i>
          Nouvelle checklist
        </button>
        <button
          type="button"
          class="btn btn-custom-primary"
          @click.prevent="
            $router
              .push({
                name: 'rh_entretien_checklist-show',
                params: { id: currentChecklist.id },
              })
              .catch(() => {})
          "
        >
          <i class="fa fa-eye font-size-17"></i> Aperçu
        </button>
      </div>
    </div>

    <div class="mt-4 mt-lg-4 mb-4">
      <div class="row">
        <div class="col-md-12">
          <b-nav tabs>
            <b-nav-item
              :to="{
                name: 'rh_entretien_checklist-edit',
                params: { id: currentChecklist.id },
              }"
              exact
              exact-active-class="active"
              ><i class="fa fa-edit text-custom-primary font-size-17"></i>
              Checklist</b-nav-item
            >

            <b-nav-item
              :to="{
                name: 'rh_entretien_checklist_edit_question',
                params: {
                  id: currentChecklist.id,
                },
              }"
              ><i class="ion ion-md-cube text-custom-primary font-size-17"></i>
              Questions</b-nav-item
            >
          </b-nav>
        </div>
      </div>

      <div>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import URL from '@/http/rh/entretien/checklist';

export default {
  data() {
    return {
      title: 'Checklists des entretiens - Edition',
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  computed: {
    ...mapGetters('checklist', ['currentChecklist']),
  },
  watch: {
    reload: {
      immediate: true,
      handler(val) {
        if (val) this.init();
      },
    },
  },
  methods: {
    ...mapActions('checklist', ['setCurrentChecklist']),
    init() {
      this.setCurrentChecklist(null);

      window.axios
        .get(URL.CHECKLIST + '/' + this.$route.params.id, {
          params: {
            edit: true,
          },
        })
        .then((resp) => {
          this.setCurrentChecklist(resp.data.checklist);
          this.reload = false;
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
